import carrelage from "../src/assets/icons/block-brick.png"
import peinture from "../src/assets/icons/paint-roller.png"
import electricite from "../src/assets/icons/bolt.png"
import plomberie from "../src/assets/icons/faucet.png"
import agencement from "../src/assets/icons/driller.png"
import jardinage from "../src/assets/icons/mower.png"
import demenagement from "../src/assets/icons/truck-loading.png"

const categories = [
    {
        name: "Carrelage",
        icon: carrelage
    },
    {
        name: "Peinture",
        icon: peinture
    },
    {
        name: "Electricité",
        icon: electricite
    },
    {
        name: "Plomberie",
        icon: plomberie
    },
    {
        name: "Agencement",
        icon: agencement
    },
    {
        name: "Jardinage",
        icon: jardinage
    },
    {
        name: "Déménagement",
        icon: demenagement
    }

]

export default categories